function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/**
 * undefined
 * @version v3.0.0
 * @link undefined
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? t(exports, require("@uirouter/angularjs"), require("@uirouter/react"), require("react"), require("angular"), require("react-dom/client"), require("@uirouter/core"), require("react-dom")) : "function" == typeof define && define.amd ? define(["exports", "@uirouter/angularjs", "@uirouter/react", "react", "angular", "react-dom/client", "@uirouter/core", "react-dom"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self)["@uirouter/react-hybrid"] = {}, e["@uirouter/angularjs"], e["@uirouter/react"], e.React, e.angular, e.ReactDOM, e["@uirouter/core"], e.ReactDOM);
}(this, function (e, t, r, n, o, i, a, c) {
  "use strict";

  function u(e) {
    var t = Object.create(null);
    return e && Object.keys(e).forEach(function (r) {
      if ("default" !== r) {
        var n = Object.getOwnPropertyDescriptor(e, r);
        Object.defineProperty(t, r, n.get ? n : {
          enumerable: !0,
          get: function get() {
            return e[r];
          }
        });
      }
    }), t.default = e, Object.freeze(t);
  }
  var l = u(n),
    p = u(o),
    f = u(c),
    s = "ui.router.react.hybrid",
    d = p.module(s, ["ui.router"]);
  d.config(["$uiRouterProvider", function (e) {
    e.viewService._pluginapi._viewConfigFactory("react", function (e, t) {
      return new r.ReactViewConfig(e, t);
    }), e.stateRegistry.decorator("views", ["e", "t", function (e, t) {
      var r = t(e),
        n = e.self,
        o = n.views || {
          $default: n
        };
      return Object.keys(r).forEach(function (e) {
        var t = r[e];
        o[e || "$default"];
        var n,
          i = ((n = t.component) instanceof l.Component || n && n.prototype && n.prototype.isReactComponent || n && n.prototype && "function" == typeof n.prototype.render || n && "function" == typeof n) && "react";
        t.$type = o[e].$type || i || t.$type;
      }), r;
    }]);
  }]);
  var y = {
    router: void 0,
    addr: void 0
  };
  function v(e) {
    var t = e.parentContextLevel,
      o = void 0 === t ? "0" : t,
      i = e.inherited,
      a = void 0 === i || i,
      c = e.children,
      u = n.useState(y),
      f = u[0],
      s = u[1],
      d = n.useContext(r.UIRouterContext),
      v = n.useContext(r.UIViewContext),
      w = n.useRef(null);
    if (!w.current) return l.createElement("div", {
      ref: function ref(e) {
        if (e && e !== w.current) {
          w.current = e;
          var t = p.element(e).injector(),
            r = null == t ? void 0 : t.get("$uiRouter"),
            n = parseInt(o, 10);
          for (n = isNaN(n) ? 0 : n; e && n--;) e = e.parentElement;
          var i = e && p.element(e).inheritedData("$uiView"),
            a = i && new h(i);
          s({
            router: r,
            addr: a
          });
        }
      }
    });
    var g = l.Children.count(c),
      m = Array.isArray(c);
    return l.createElement(r.UIRouterContext.Provider, {
      value: a && d || f.router
    }, l.createElement(r.UIViewContext.Provider, {
      value: a && v || f.addr
    }, 1 !== g || m ? l.createElement("div", null, c) : l.Children.only(c)));
  }
  var h = function () {
      function e(e) {
        if (this._ngdata = e, !e) throw new Error("@uirouter/react-hybrid: Address Adapter created with no _ngdata parameter.");
      }
      return Object.defineProperty(e.prototype, "fqn", {
        get: function get() {
          return this._ngdata.$uiView.fqn;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(e.prototype, "context", {
        get: function get() {
          if (!this._ngdata || !this._ngdata.$cfg || !this._ngdata.$cfg.viewDecl) throw console.log(this._ngdata), new Error("@uirouter/react-hybrid: Uh oh. Views are in an invalid state. Parent UIView has no $cfg or viewDecl");
          return this._ngdata.$cfg.viewDecl.$context || this._ngdata.$uiView.creationContext;
        },
        enumerable: !1,
        configurable: !0
      }), e;
    }(),
    w = function w(e, t, r) {
      if (r || 2 === arguments.length) for (var n, o = 0, i = t.length; o < i; o++) !n && o in t || (n || (n = Array.prototype.slice.call(t, 0, o)), n[o] = t[o]);
      return e.concat(n || Array.prototype.slice.call(t));
    },
    g = function g(e, t, r, n, o) {
      for (var i = [], c = 5; c < arguments.length; c++) i[c - 5] = arguments[c];
      window && !0 !== window.debugReactHybrid || console.log.apply(console, w(["".concat(a.padString(12, e), " ").concat(a.padString(40, "".concat(t, "[").concat(r, "]")), " ").concat(a.padString(35, "".concat(n, ":")), " ").concat(o)], i, !1));
    },
    _m = function m() {
      return _m = Object.assign || function (e) {
        for (var t, r = 1, n = arguments.length; r < n; r++) for (var o in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }, _m.apply(this, arguments);
    },
    b = function b(e, t) {
      var r = {};
      for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for (n = Object.getOwnPropertySymbols(e); o < n.length; o++) t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
      }
      return r;
    },
    O = r.UIView.__internalViewComponent,
    P = function P(e) {
      var t = e.refFn,
        r = b(e, ["refFn"]);
      g("react", "ReactUIView", "?/".concat(r.name), ".render()", "");
      var n = _m(_m({}, r), {
        ref: t
      });
      return l.createElement(v, {
        parentContextLevel: "3",
        inherited: !1
      }, l.createElement(O, _m({}, n)));
    },
    _V = function V() {
      return _V = Object.assign || function (e) {
        for (var t, r = 1, n = arguments.length; r < n; r++) for (var o in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }, _V.apply(this, arguments);
    },
    j = function j(e, t, r) {
      if (r || 2 === arguments.length) for (var n, o = 0, i = t.length; o < i; o++) !n && o in t || (n || (n = Array.prototype.slice.call(t, 0, o)), n[o] = t[o]);
      return e.concat(n || Array.prototype.slice.call(t));
    };
  var $ = new WeakMap();
  !function (e) {
    d.directive("uiView", function () {
      return {
        restrict: "AE",
        compile: function compile(e, t) {
          var r = t.name,
            n = t.uiView;
          r = r || n || "$default", g("angularjs", "ui-view", "?", ".compile()", "Creating react-ui-view-adapter", e), e.html('<react-ui-view-adapter name="'.concat(r, '"></react-ui-view-adapter>'));
        }
      };
    });
    var t = 0;
    d.directive("reactUiViewAdapter", function () {
      return {
        restrict: "E",
        link: function link(r, n, o) {
          var i = function i(e, t) {
              for (var r = [], n = 2; n < arguments.length; n++) r[n - 2] = arguments[n];
              return g.apply(void 0, j(["angularjs", "react-ui-view-adapter", "".concat(f, "/").concat(o.name), e, t], r, !1));
            },
            c = n[0],
            u = null,
            p = !1,
            f = t++,
            s = ["$$element", "$attr"];
          o = a.filter(o, function (e, t) {
            return -1 === s.indexOf(t);
          }), i(".link()", "linking react-ui-view-adapter into ", c, o);
          var d = function d(e) {
              e && u === e || !e && u || (u = e, i(".ref()", "Received new React UIView ref", e), v(), h());
            },
            y = function y(e, t) {
              return i(".render()", "has ref: ".concat(!!u)), v(), u ? l.createElement(e, t) : null;
            },
            v = function v() {
              var e,
                t = null === (e = null == u ? void 0 : u.uiViewData) || void 0 === e ? void 0 : e.config,
                r = null == u ? void 0 : u.uiViewAddress;
              i(".provideContextToAngularJSChildren", "", c, t, r), t && r ? n.data("$uiView", {
                $cfg: t,
                $uiView: r
              }) : n.removeData("$uiView");
            };
          function h() {
            if (p) i(".renderReactUIView()", "already destroyed -- will not render React UIView");else {
              var t = _V(_V({}, o), {
                  render: y,
                  wrap: !1,
                  refFn: d
                }),
                n = r.$uiRouterReactHybridPortalView;
              if (n) i(".renderReactUIView()", "will createPortalToChildUIView({ name: '".concat(t.name, "' })"), c), n.createPortalToChildUIView(f, {
                childUIViewProps: t,
                portalTarget: c
              });else {
                i(".renderReactUIView()", 'rendering <ReactUIView name="'.concat(t.name, '"/>'), c);
                var a = l.createElement(P, _V({}, t));
                e.render(a, c);
              }
            }
          }
          r.$on("$destroy", function () {
            p = !0;
            var t = r.$uiRouterReactHybridPortalView;
            t ? t.removePortalToChildUIView(f) : (e.unmount(c), i('.$on("$destroy")', "unmounted", c)), n.remove();
          }), h();
        }
      };
    });
  }({
    render: function render(e, t) {
      var r = $.get(t);
      r || (r = i.createRoot(t), $.set(t, r)), r.render(e);
    },
    unmount: function unmount(e) {
      var t = $.get(e);
      t && (t.unmount(), $.delete(e));
    }
  });
  var _U,
    C,
    I,
    R = (_U = function U(e, t) {
      return _U = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (e, t) {
        e.__proto__ = t;
      } || function (e, t) {
        for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
      }, _U(e, t);
    }, function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
      function r() {
        this.constructor = e;
      }
      _U(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
    }),
    _2 = function _() {
      return _2 = Object.assign || function (e) {
        for (var t, r = 1, n = arguments.length; r < n; r++) for (var o in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }, _2.apply(this, arguments);
    },
    E = function E(e, t) {
      var r = {};
      for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for (n = Object.getOwnPropertySymbols(e); o < n.length; o++) t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
      }
      return r;
    };
  d.run(["$injector", function (e) {
    C = e.get("$rootScope"), I = e.get("$compile");
  }]);
  var x = function (e) {
      function t(t) {
        var r = e.call(this, t) || this;
        return r.$scope = C.$new(), r.$scope.$uiRouterReactHybridPortalView = r.props.portalView, r;
      }
      return R(t, e), t.prototype.componentWillUnmount = function () {
        this.$scope.$destroy();
      }, t.prototype.render = function () {
        var e = this,
          t = this.props,
          r = t.className,
          n = E(t, ["className"]),
          o = _2(_2({}, n), {
            class: r,
            ref: function ref(t) {
              return I(t)(e.$scope);
            }
          });
        return l.createElement("ui-view", o);
      }, t.prototype.shouldComponentUpdate = function () {
        return !1;
      }, t;
    }(l.Component),
    T = function () {
      var _e = function e(t, r) {
        return _e = Object.setPrototypeOf || {
          __proto__: []
        } instanceof Array && function (e, t) {
          e.__proto__ = t;
        } || function (e, t) {
          for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        }, _e(t, r);
      };
      return function (t, r) {
        if ("function" != typeof r && null !== r) throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
        function n() {
          this.constructor = t;
        }
        _e(t, r), t.prototype = null === r ? Object.create(r) : (n.prototype = r.prototype, new n());
      };
    }(),
    _A = function A() {
      return _A = Object.assign || function (e) {
        for (var t, r = 1, n = arguments.length; r < n; r++) for (var o in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }, _A.apply(this, arguments);
    },
    S = function S(e, t, r) {
      if (r || 2 === arguments.length) for (var n, o = 0, i = t.length; o < i; o++) !n && o in t || (n || (n = Array.prototype.slice.call(t, 0, o)), n[o] = t[o]);
      return e.concat(n || Array.prototype.slice.call(t));
    },
    D = 0,
    k = function (e) {
      function t() {
        var t = null !== e && e.apply(this, arguments) || this;
        return t.$id = D++, t.state = {
          portals: []
        }, t.debug = function (e, r) {
          for (var n = [], o = 2; o < arguments.length; o++) n[o - 2] = arguments[o];
          return g.apply(void 0, S(["react", "PortalView", "".concat(t.$id, "/").concat(t.props.name), e, r], n, !1));
        }, t.createPortalToChildUIView = function (e, r) {
          t.debug(".createPortalToChildUIView()", JSON.stringify(r.childUIViewProps), r.portalTarget), t.setState(function (t) {
            var n;
            return {
              portals: _A(_A({}, t.portals), ((n = {})[e] = r, n))
            };
          });
        }, t.removePortalToChildUIView = function (e) {
          var r = t.state.portals[e] || {};
          t.debug(".removePortalToChildUIView()", "".concat(e), r.childUIViewProps, r.portalTarget), t.setState(function (t) {
            var r = _A({}, t.portals);
            return delete r[e], {
              portals: r
            };
          });
        }, t;
      }
      return T(t, e), t.prototype.componentWillUnmount = function () {
        this.debug(".componentWillUnmount()", "");
      }, t.prototype.renderPortals = function () {
        var e = this,
          t = this.state.portals;
        return Object.keys(t).forEach(function (r) {
          var n = t[r];
          e.debug(".renderPortals()", "ReactDOM.createPortal(".concat(r, ")"), "", n.childUIViewProps, n.portalTarget);
        }), Object.keys(t).map(function (e) {
          var r = t[e];
          return l.createElement("div", {
            style: {
              display: "none"
            },
            key: "".concat(e)
          }, f.createPortal(l.createElement(P, _A({}, r.childUIViewProps)), r.portalTarget));
        });
      }, t.prototype.render = function () {
        return this.debug(".render()", ""), l.createElement(l.Fragment, null, l.createElement(x, _A({}, this.props, {
          portalView: this
        })), this.renderPortals());
      }, t;
    }(l.PureComponent),
    _q = function q() {
      return _q = Object.assign || function (e) {
        for (var t, r = 1, n = arguments.length; r < n; r++) for (var o in t = arguments[r]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }, _q.apply(this, arguments);
    },
    M = r.UIView.prototype.render;
  r.UIView.prototype.render = function () {
    if (!1 === this.props.wrap) {
      var e = "".concat(this.$id, "/").concat(this.props.name);
      return g("react", "UIViewMonkeyPatch", e, ".render()", "realRender.apply(this, arguments)"), M.apply(this, arguments);
    }
    return l.createElement(k, _q({}, this.props));
  }, e.UIRouterContext = function (e) {
    return function (t) {
      return l.createElement(v, null, l.createElement(e, t));
    };
  }, e.UIRouterContextComponent = v, e.UI_ROUTER_REACT_HYBRID = s, e.hybridModule = d;
});